module.exports = __webpack_public_path__ + "img/72.7789e97c.jpg";